import React from "react";
import { Alert } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";

export const DemoBanner: React.FC = () => {
	const { user } = useAuth0();

	// Get metadata from Auth0
	const userMetadata = user?.["https://arteh.com.au/user_metadata"];
	const appMetadata = user?.["https://arteh.com.au/app_metadata"];

	// Check if in demo mode
	const isDemoMode = userMetadata?.isDemoMode === true;

	// Alternative: check if active company is demo type
	const activeCompanyId = userMetadata?.activeCompanyId;
	const activeCompany = appMetadata?.companies?.find(
		(c: any) => c.id === activeCompanyId,
	);
	const isActiveCompanyDemo = activeCompany?.type === "demo";

	// Show banner if either condition is true
	const showBanner = isDemoMode || isActiveCompanyDemo;

	if (!showBanner) {
		return null;
	}

	return (
		<Alert
			severity="info"
			sx={{
				mb: 2,
				backgroundColor: "#5DBEC3",
				color: "white",
				"& .MuiAlert-icon": {
					color: "white",
				},
			}}
		>
			<strong>Demo Company</strong> - You're exploring with sample
			emissions data. To track your own carbon footprint, switch to
			your company using the dropdown below.
		</Alert>
	);
};
